export default __webpack_public_path__ + "static/american-express-cb9495a07b26daabe6abc3a23f67db2d.svg";